// src/components/ResponsiveFooter.jsx
import React, { useState, useEffect } from 'react';
import DesktopFooter from './DesktopFooter';
import MobileFooter from './MobileFooter';

interface ResponsiveFooterProps {
  onOpenEnquireModal: () => void;
  onOpenMobileEnquireModal: () => void;
  footerInView?: boolean;
}

const ResponsiveFooter: React.FC<ResponsiveFooterProps> = ({ onOpenEnquireModal, onOpenMobileEnquireModal, footerInView }) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 500 : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 500);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile 
    ? <MobileFooter onOpenEnquireModal={onOpenMobileEnquireModal} /> 
    : <DesktopFooter onOpenEnquireModal={onOpenEnquireModal} footerInView={footerInView} />;
};

export default ResponsiveFooter;
